import Vue from 'vue';
import store from '@/store';
import { abilitiesPlugin } from '@casl/vue';
import { ABILITY_ACTIONS, ABILITY_SUBJECTS } from '@/constants/abilityParams';

Vue.use(abilitiesPlugin, store.getters['authorization/ability']);
Vue.prototype.$abilityActions = ABILITY_ACTIONS;
Vue.prototype.$abilitySubjects = ABILITY_SUBJECTS;
